import { WELLNESS_REIMBURSEMENT_URL } from '../constants';

export const wellnessPlanFaqsData = [
  {
    header: 'What is a wellness plan?',
    body: 'Wellness plans are customized packages of routine care that every pet needs. Plans cover essential treatments such as routine wellness exams, routine blood work and other diagnostics, vaccines and boosters, flea and tick meds, dental cleaning and even spay/neuter procedures.',
  },
  {
    header: 'How long do plans last?',
    body: 'Our wellness plans are 12 month terms, and because pets need ongoing preventative care, they automatically renew (unless you cancel) at the end of the 12 month term.',
  },
  {
    header: 'Where can the plan be used?',
    body: 'Plans can be used at any licensed veterinarian.',
  },
  {
    header: 'When can plans be used?',
    body: 'Once signed up, you can begin to use it 24 hours after you enroll. You will receive an email confirming your subscription and how to submit a claim for payment.',
  },
  {
    header: 'Does this cover pre-existing conditions?',
    body: 'Our wellness plans cover all pets, regardless of any pre-existing conditions they may have. So even if your pet has a pre-existing condition, you can sign them up and have the same care at the same price as every other pet. Pre-existing conditions are something insurance plans care about, and our wellness plans are not insurance.',
  },
  {
    header: 'Is this an insurance policy?',
    body: '<p> No, this is not an insurance policy. While pet insurance covers future unforeseen circumstances such as accidents and illnesses, it does not cover the routine wellness care and treatments that our plans offer. Our plans include routine wellness exams, vaccines and boosters, flea/tick meds, and more. </p>'
    + '<p> In summary, as opposed to an insurance plan that you’ll only use if something unexpected happens to your pet (e.g., it gets sick or has an accident), with our routine wellness plans you’ll use the benefits each year as recommended by your vet. </p>'
    + '<p> Important: If you also have a pet insurance policy for accidents and illnesses, and don’t keep up with the routine wellness recommendations your vet has made, claims may be rejected for anything that’s related to the missing wellness care. </p>',
  },
  // TODO: Uncomment when we begin supporting this discount
  // {
  //   header: 'What if I have multiple pets?',
  //   body: 'You’ll get a 15% discount on all pets if you sign up for a wellness plan for more '
  //     + 'than 1 pet.',
  // },
  {
    header: 'Can I change my plan during the year?',
    body: 'Your plan is priced based on the level of benefits you’re likely to need during the year, and therefore you can only change your plan level at the 12 month anniversary.',
  },
  {
    header: 'How can I cancel my plan?',
    body: '<p> Here’s how our cancellation policy works: </p>'
      + '<ul>'
      + '<li> No Requests for Reimbursement Made – you can cancel anytime with no cancellation fee due. However, you will not be refunded for any plan payments made. </li>'
      + '<li> If You’ve Made a Request for Reimbursement – if you wish to cancel before the end of the 12 month term, there is a cancellation fee due of the LESSER of the amount paid in reimbursements or the balance left to pay on the plan. You will not be refunded for any plan payments made. </li>'
      + '</ul>'
      + '<p> Note: If your pet passes away and you send us a copy of the death certificate or other proof from your vet, we will IMMEDIATELY cancel your plan and you will NOT be charged a cancellation fee. This is subject to verification. You will not be refunded for any plan payments made. </p>',
  },
  {
    header: 'How do I change my contact details or payment method?',
    body: '<p> You can change your contact details and/or payment method in the Wag! App or on <a href="https://app.wagwalking.com" target="_blank"> app.wagwalking.com </a> </p>',
  },
  {
    header: 'How do I submit a bill for reimbursement?',
    body: `<p> Simply visit the Wag! Wellness <a href="${WELLNESS_REIMBURSEMENT_URL}">reimbursement form</a> to enter your contact information and details on the wellness treatment for which you would like to receive reimbursement. You are also required to attach proof of treatment via a vet record or receipt. Our team will then verify your information and ensure the treatment is covered under your current wellness plan. We will then transfer the approved funds to your PayPal account within 24 hours of your request. </p>`
    + '<p> Note: The 24 hour timeframe only applies to weekdays and your reimbursement may take 1-2 additional days if requested during the weekend. </p>',
  },
];
